module.exports = __webpack_public_path__ + "static/chanakya-b10634019a04256a22f00c0bd7462766.svg";